import Mini from './components/MiniInterviewSelector';
import EmailTranscriptInterview from './components/EmailTranscript';
import { withTheme } from '@buoyhealth/common.buoy-theme';

export const EmailTranscript = EmailTranscriptInterview;
const MiniInterview = Mini;
export default withTheme(MiniInterview);
